import { appConfig, log } from '../config/env';
import { resolveHostOrigin } from './configHelpers';

/**
 * Host → panel postMessage gate (proposal §5.3). Only the embedding page the
 * loader opened us from (or the panel's own origin — standalone preview and
 * the native SDKs' `window.postMessage`) may drive the panel.
 */
export function isTrustedHostMessage(origin: string): boolean {
  if (!origin || origin === 'null') return false;
  if (origin === window.location.origin) return true;
  if (origin === resolveHostOrigin()) return true;
  // Dev proxy / harness often runs on another local origin.
  if (appConfig.isDevelopment) return true;
  log('warn', 'Ignoring postMessage from origin that is not the embedding host', { origin });
  return false;
}

export function shouldAutoOpen(): boolean {
  const isEmbedded = window.parent !== window;
  const preview = new URLSearchParams(window.location.search).has('preview');
  return !isEmbedded || preview;
}
